import Core6Utilities from "./Core6Utilities";

export default class Core6Lightbox {
  constructor() {
    this.groupImages = [];
    this.currImage = 0;

    this.initListeners();
  }

  initListeners() {
    $('body').on('click touchstart', '.lightbox_body .lb_slider_arrow_prev', { self: this }, Core6Lightbox.previousImage);
    $('body').on('click touchstart', '.lightbox_body .lb_slider_arrow_next', { self: this }, Core6Lightbox.nextImage);
    $('body').on('click touchstart', '.lightboxMe', { self: this }, Core6Lightbox.showLightbox);
  }

  static previousImage(ev) {
    const { self } = ev.data;
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    console.log(self.currImage);
    if (self.currImage <= 0) {
      self.currImage = self.groupImages.length - 1;
    } else {
      self.currImage -= 1;
    }
    const img = self.groupImages[self.currImage];
    $('#lightboxImage').attr('src', img);
    return false;
  }

  static nextImage(ev) {
    const { self } = ev.data;
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    console.log(self.currImage);
    if (self.currImage >= (self.groupImages.length - 1)) {
      self.currImage = 0;
    } else {
      self.currImage += 1;
    }
    const img = self.groupImages[self.currImage];
    $('#lightboxImage').attr('src', img);
    return false;
  }

  static showLightbox(ev) {
    const { self } = ev.data;
    self.groupImages = [];
    if (ev.target.getAttribute('data-core6_slider_current_image_index') !== undefined && ev.target.getAttribute('data-core6_slider_current_image_index') !== null) {
      self.currImage = ev.target.getAttribute('data-core6_slider_current_image_index') * 1;
    } else {
      self.currImage = 0;
    }

    const images = ev.target.getAttribute('data-core6_slider_images');
    //console.log(images);
    const imagesArr = images.split(';');
    //console.log(imagesArr);

    $.each(imagesArr, (index, value) => {
      self.groupImages.push(`/large/${value}`);
    });

    if (self.groupImages.length === 1) {
      Core6Utilities.getJQueryElement('.lightbox_body .slider_arrow_next').hide();
      Core6Utilities.getJQueryElement('.lightbox_body .slider_arrow_prev').hide();
    } else {
      Core6Utilities.getJQueryElement('.lightbox_body .slider_arrow_next').show();
      Core6Utilities.getJQueryElement('.lightbox_body .slider_arrow_prev').show();
    }

    const img = self.groupImages[self.currImage];
    //console.log(img);

    Core6Utilities.getJQueryElement('#lightboxImage').attr('src', img);
    Core6Utilities.getJQueryElement('#lightboxModal').modal();
  }
}

/* $('body').on('click', '.lightbox_body .slider_arrow_prev', (ev) => {
  ev.preventDefault();
  ev.stopPropagation();
  ev.stopImmediatePropagation();
  if (currImage <= 0) {
    currImage = groupImages.length - 1;
  } else {
    currImage--;
  }
  const img = groupImages[currImage];
  $('#lightboxImage').attr('src', img);
  return false;
}); */

/* $('body').on('click', '.lightbox_body .slider_arrow_next', (ev) => {
  ev.preventDefault();
  ev.stopPropagation();
  ev.stopImmediatePropagation();
  if (currImage >= (groupImages.length - 1)) {
    currImage = 0;
  } else {
    currImage++;
  }
  const img = groupImages[currImage];
  $('#lightboxImage').attr('src', img);
  return false;
}); */

/* $('body').on('click touchstart', '.lightboxMe', (evt) => {
  groupImages = [];
  if (evt.target.getAttribute('data-core6_slider_current_image_index') !== undefined) {
    currImage = evt.target.getAttribute('data-core6_slider_current_image_index');
  } else {
    currImage = 0;
  }

  const images = evt.target.getAttribute('data-core6_slider_images');
  const imagesArr = images.split(';');

  $.each(imagesArr, (index, value) => {
    groupImages.push(`/large/${value}`);
  });

  if (groupImages.length === 1) {
    $('.lightbox_body .slider_arrow_next').hide();
    $('.lightbox_body .slider_arrow_prev').hide();
  } else {
    $('.lightbox_body .slider_arrow_next').show();
    $('.lightbox_body .slider_arrow_prev').show();
  }

  const img = groupImages[currImage];

  $('#lightboxImage').attr('src', img);
  $('#lightboxModal').modal();
}); */




// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6Lightbox.js